import { Component, OnInit } from '@angular/core';
import { UtilitySharedService } from '../../../services/shared/utility-shared.service';
import { SectionDefinitionService } from '../../../services/section-definition.service';
import { ToastrService } from 'ngx-toastr';
import { SectionDefinition, SectionDefinitionEntityType } from '../../../models/section-definition.model';
import { CimClass } from '../../../models/network-structure.model';

@Component({
  selector: 'lib-network-lines',
  templateUrl: './network-lines.component.html',
  styleUrls: ['./network-lines.component.scss'],
  standalone: false
})
export class NetworkLinesComponent implements OnInit {
  utilityId: number = 0;
  sectionDefinitions: SectionDefinition[] = [];
  expandedSectionId: number = -1;
  addNewFieldOpened: boolean = false;
  selectedClass: number = 0;
  entityType: number = SectionDefinitionEntityType.EquipmentTemplate;
  classes: { index: number; label: string; cimClass: CimClass }[] = [];

  constructor(
    private utilitySharedService: UtilitySharedService,
    private sectionDefinitionService: SectionDefinitionService,
    private toastr: ToastrService
  ) {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnInit(): void {
    this.classes = Object.entries(CimClass)
      .filter(([, value]) => typeof value === 'number' && (value as number) !== CimClass.Substation)
      .map(([key, value], index) => ({
        index,
        label: key.replace(/([a-z])([A-Z])/g, '$1 $2'),
        cimClass: value as CimClass
      }));

    this.selectClass(0);
  }

  getSectionDefinitionsForClass(cimClass: CimClass) {
    this.sectionDefinitionService.getAllSectionDefinitionsForDmc(this.entityType, this.utilityId, 0, cimClass).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sectionDefinitions = responseData?.data?.length
            ? responseData?.data?.map((el: any) => new SectionDefinition(el))
            : [];
          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }

  onSectionUpdated(data: any) {
    this.getSectionDefinitionsForClass(this.classes[this.selectedClass].cimClass);
  }

  selectClass(index: number) {
    this.selectedClass = index;
    this.getSectionDefinitionsForClass(this.classes[index].cimClass);
  }

  sectionSaved(data: any) {
    this.getSectionDefinitionsForClass(this.classes[this.selectedClass].cimClass);
    this.expandedSectionId = data.id;
    this.addNewFieldOpened = false;
  }

  sectionDeleted(id: any) {
    this.sectionDefinitions = this.sectionDefinitions.filter(x => x.id != id);
  }
}
